import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

import { localStorageKey } from './stores/slice/lang';

let lng = localStorage.getItem(localStorageKey);
if (!lng) {
   lng = 'en';
}

i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: {
      loadPath: "/locales/{{lng}}/dict.json",
    },
    fallbackLng: 'en',
    lng,
    interpolation: {
      escapeValue: false
    },
    // allow keys to be phrases having `:`, `.`
    nsSeparator: false,
    keySeparator: false,
  });

export default i18n;